import React from 'react';
import MainContainer from './MainContainer';
import Success from './Success';

const SuccessPage = () => {
    return (
        <MainContainer>
            <Success />
        </MainContainer>
    );
};

export default SuccessPage;
